<template>
	<div class="p-6 flex flex-col justify-center space-y-6">
		<h2 class="text-4xl font-bold text-gray-900">
			{{ __("Welcome") }}
			{{ user.name }},
			{{ __("glad you are here!") }}
		</h2>

		<p>
			Machen Sie jetzt ihr Kauf- und Verkaufsinteresse auf der Karte sichtbar
			und erweitern Sie ihren Aktionsradius. Jetzt in drei einfachen Schritten
			ein unverbindliches Inserat erstellen!
		</p>

		<div>
			<page-link
				:absolute="true"
				acl="can_trade"
				:href="$route('offer_all.index')"
				type="button"
				class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-transparent shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
				v-on:click="
					$bus.$emit('toggle-iframe-modal', $route('offers_sell.create'))
				"
				>{{ __("New Offer") }}
			</page-link>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
	},
};
</script>
